// extracted by mini-css-extract-plugin
module.exports = {"cp-signin":"styles_cp-signin__2ePtK"};